import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, clearSubmitErrors } from 'redux-form';
import validate from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import { copyFor, capitalization } from '../../copy/copy';

const Title = styled.div`
    font-size: 16px;
    font-weight: 300;
    line-height: 1.38;
    color: #000000;
    margin-bottom: 10px;
    ${props => (props.skipLinkVisible ? `padding-right: 80px;` : '')};

    @media (max-width: 30em) {
        ${props => (props.skipLinkVisible ? `padding-right: 30px;` : '')};
    }
`;

const Skip = styled.span`
    font-family: Lato;
    font-size: 10px;
    line-height: 1.6;
    color: #008eff;
    position: absolute;
    right: 0;
    top: 5px;
    cursor: pointer;
`;

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            margin: 0 !important;
            ${props => (props.isEmailSubmitting ? `text-indent: -99999px;` : '')};
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: 50%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;

            ${props => (props.isEmailSubmitting ? `display: block` : '')};
        }
    }
`;

const EmailInterstitialContainer = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
`;

const FormGroup = styled.div`
    margin-bottom: 0.75em;
`;

const EmailInterstitialForm = props => (
    <EmailInterstitialContainer
        onSubmit={props.handleSubmit}
        autocomplete="on"
        isEmailSubmitting={props.isEmailSubmitting}
    >
        <Title skipLinkVisible={props.skipLinkVisible}>
            {props.collectEmailText}
            {props.skipLinkVisible && (
                <Skip onClick={props.skipInterstitialPopup}>
                    {copyFor('emailInterstitial', 'skip')}
                </Skip>
            )}
        </Title>
        <FormGroup>
            <Field
                className={'fs-block'}
                name="email"
                component={InputGroup}
                type="email"
                label="Email"
                placeholder={copyFor(
                    'placeholders',
                    'emailAddress',
                    undefined,
                    capitalization.eachWord
                )}
                autocomplete="off"
            />
        </FormGroup>
        <ButtonGroup isEmailSubmitting={props.isEmailSubmitting}>
            <TwoGroup>
                <Button
                    primary={true}
                    label={copyFor(
                        'buttons',
                        'submit',
                        undefined,
                        capitalization.eachWord
                    )}
                    type="submit"
                    className="submitButton"
                    disabled={props.invalid}
                />
                <LoadingSpinner />
            </TwoGroup>
        </ButtonGroup>
    </EmailInterstitialContainer>
);

EmailInterstitialForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isEmailSubmitting: PropTypes.bool,
    skipInterstitialPopup: PropTypes.func,
    skipLinkVisible: PropTypes.bool,
    collectEmailText: PropTypes.string
};

export default compose(
    connect(state => ({
        initialValues: {
            email: state.cachedFormData.email || ''
        }
    })),
    reduxForm({
        form: 'emailInterstitialForm',
        onChange: (values, dispatch) => {
            dispatch(clearSubmitErrors('emailInterstitialForm'));
        },
        validate
    })
)(EmailInterstitialForm);
